module.exports = __webpack_public_path__ + "img/img-ios-guide.84e0ed5c.png";